class RxHubOrdersComponent {
  constructor(Orders) {
    Object.assign(this, {
      Orders,
      pagination: {
        limit: 20,
        total: 9999,
        offset: 0,
        sort: 'dispense_order_id',
        order: 'desc',
        search: '',
      },
      isLoading: false,
      BODACDC_3272: FEATURE_BODACDC_3272,
    });
  }

  $onInit() {
    if(this.BODACDC_3272) {
      this.getRxHubIntegrations();
    }
  }

  onPageChange() {
    this.getRxHubIntegrations();
  }

  onSortChange() {
    this.getRxHubIntegrations();
  }

  onSearchOrderTab(){
    this.getRxHubIntegrations();
  }

  getRxHubIntegrations() {
    this.isLoading = true;
    this.Orders.getRxhubIntegrations(this.pagination)
      .then(({ data }) => {
        const { orders } = data;
        this.orders = orders;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

RxHubOrdersComponent.$inject = ['Orders'];
angular.module('pims').component('rxHubOrdersTable', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/table/orders/rx-hub-orders.component.html',
  controller: RxHubOrdersComponent,
  controllerAs: 'vm',
  bindings: {
    orders: '='
  }
});